// Composables
import { createRouter, createWebHashHistory } from 'vue-router'

const publics = [
  {
    path: '/login',
    component: () => import('@/views/login.vue'),
  },
];

const commons = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/app/dashboard.vue'),
  },
  {
    path: '/documents/:aendexId?',
    name: 'Documents',
    component: () => import('@/views/app/content/documents.vue'),
  },
  {
    path: '/queue',
    name: 'Queue',
    component: () => import('@/views/app/content/queue.vue'),
  },
  {
    path: '/failed',
    name: 'Failed',
    component: () => import('@/views/app/content/failed.vue'),
  },
  {
    path: '/semantic-search',
    name: 'SemanticSearch',
    component: () => import('@/views/app/discover/semantic-search.vue'),
  },
  {
    path: '/keyword-search',
    name: 'KeywordSearch',
    component: () => import('@/views/app/discover/keyword-search.vue'),
  },
  {
    path: '/adhoc',
    name: 'AdhocQuery',
    component: () => import('@/views/app/discover/adhoc-query.vue'),
  },
  {
    path: '/query',
    name: 'RAGQuery',
    component: () => import('@/views/app/discover/rag-query.vue'),
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/app/discover/chat.vue'),
  },
  {
    path: '/admin/audit',
    name: 'Audit',
    component: () => import('@/views/app/monitor/audit.vue'),
  },
  {
    path: '/admin/analytics',
    name: 'Analytics',
    component: () => import('@/views/app/monitor/analytics.vue'),
  },
  {
    path: '/admin/conversations',
    name: 'Conversations',
    component: () => import('@/views/app/monitor/conversations.vue'),
  },
  {
    path: '/admin/conversations/:sessionId',
    name: 'ChatSession',
    component: () => import('@/views/app/monitor/chat-session.vue'),
  },
  {
    path: '/admin/saved-queries',
    name: 'SavedQueries',
    component: () => import('@/views/app/admin/saved-queries.vue'),
  },
  {
    path: '/admin/tools',
    name: 'Tools',
    component: () => import('@/views/app/admin/tools.vue'),
  },
  {
    path: '/admin/users',
    name: 'Users',
    component: () => import('@/views/app/admin/users.vue'),
  },
  {
    path: '/content-tasks',
    name: 'ContentTasks',
    component: () => import('@/views/app/tasks/task-list.vue'),
  },
  {
    path: '/analysis-tasks',
    name: 'AnalysisTasks',
    component: () => import('@/views/app/tasks/task-list.vue'),
  },
  {
    path: '/compliance-tasks',
    name: 'ComplianceTasks',
    component: () => import('@/views/app/tasks/task-list.vue'),
  },
  {
    path: '/vision-tasks',
    name: 'VisionTasks',
    component: () => import('@/views/app/tasks/task-list.vue'),
  },
  {
    path: '/admin/repositories',
    name: 'Repositories',
    component: () => import('@/views/app/admin/repositories.vue'),
  },
  {
    path: '/admin/sites',
    name: 'Sites',
    component: () => import('@/views/app/admin/sites.vue'),
  },
  {
    path: '/admin/metadatarules',
    name: 'Metadata rules',
    component: () => import('@/views/app/admin/metadataRules.vue'),
  },
  {
    path: '/admin/glossary',
    name: 'Glossary',
    component: () => import('@/views/app/admin/glossary.vue'),
  },
  {
    path: '/admin/client-info',
    name: 'ClientInfo',
    component: () => import('@/views/app/admin/client-info.vue'),
  },
  {
    path: '/admin/keys',
    name: 'Keys',
    component: () => import('@/views/app/admin/keys.vue'),
  },
  {
    path: '/admin/embed',
    name: 'EmbedAendex',
    component: () => import('@/views/app/admin/embed.vue'),
  }
]


const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: [...publics, ...commons],
})

export default router
